export class DataFlowFeedback {
    id: number;
    timestampUTC: Date;
    installationName: string;
    dataFlowStep: DataFlowStep;
    type: FeedbackType;
    dataFlowGuid: string;
    description: string;
    transactionId: string;
    receivedTimestampUTC: Date;

    constructor() {
        this.id = 0;
        this.timestampUTC = new Date();
        this.installationName = "";
        this.dataFlowStep = DataFlowStep.Unknown;
        this.type = FeedbackType.Unknown;
        this.dataFlowGuid = "";
        this.description = "";
        this.transactionId = "";
        this.receivedTimestampUTC = new Date();
    }

    public parse(obj: any): void {
        if (obj == null) return;

        if (obj.Id != null) this.id = obj.Id;
        if (obj.TimestampUTC != null) this.timestampUTC = new Date(obj.TimestampUTC);
        if (obj.InstallationName != null) this.installationName = obj.InstallationName;

        // Verifica che il valore di DataFlowStep sia un valore valido dell'enum DataFlowStep
        if (obj.DataFlowStep != null && Object.values(DataFlowStep).includes(obj.DataFlowStep)) {
            this.dataFlowStep = obj.DataFlowStep as DataFlowStep;
        }

        // Verifica che il valore di FeedbackType sia un valore valido dell'enum FeedbackType
        if (obj.Type != null && Object.values(FeedbackType).includes(obj.Type)) {
            this.type = obj.Type as FeedbackType;
        }

        if (obj.DataFlowGuid != null) this.dataFlowGuid = obj.DataFlowGuid;
        if (obj.Description != null) this.description = obj.Description;
        if (obj.TransactionId != null) this.transactionId = obj.TransactionId;
        if (obj.ReceivedTimestampUTC != null) this.receivedTimestampUTC = new Date(obj.ReceivedTimestampUTC);
    }
}

export enum DataFlowStep {
    Unknown,
    Receiving,
    Inserting,
    Parsing,
    Loading,
    Conversion,
    Sending,
}

export function GetI18nStringFromDataFlowStep(val: DataFlowStep): string {
    return `enum.dataFlowStep.${DataFlowStep[val]}`;
}

export enum FeedbackType {
    Unknown,
    Ok,
    Error,
    Warning,
    Start,
}

export function GetI18nStringFromFeedbackType(val: FeedbackType): string {
    return `enum.feedbackType.${FeedbackType[val]}`;
}
